export default __webpack_public_path__ + "static/media/sticker-K.1748f817.png";